export enum SoundtrackUploadStatusEnum {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
